import './style.scss';
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import Dialog, { IDefaultDialogProps } from '../../../../../components/Dialog';
import Gallery from '../Gallery';
import RequestQuote from '../RequestQuote';


interface IAttractionDialogProps extends IDefaultDialogProps {
    attraction: any;
}


const AttractionDialog: React.FC<IAttractionDialogProps> = ({
    open,
    handleClose,
    attraction
}) => {
    const { translate } = useLanguageContext();

    return <Dialog 
        open={open}
        handleClose={handleClose}
        onCloseEventEnabled={true}
        title=''
        className='container-attractiondialog'
        maxWidth='md'
        fullWidth={true}
    >
        <Box className='attractiondialog-wallpaper' sx={{ backgroundImage: `url(${attraction?.wallpaper})` }}>
            <Typography variant='subtitle2' className='attractiondialog-wallpaper-type'>
                {attraction?.Icon && <attraction.Icon />}
                {translate(attraction?.type)}
            </Typography>
            
            <Typography variant='subtitle2' className='attractiondialog-wallpaper-name'>{attraction?.name}</Typography>
        </Box>

        <Box paddingY={6} />

        {/* Description */}
        <Box className='attractiondialog-section'>
            {
                (translate(attraction?.description) ?? '').split('\n').map((d, index) => {
                    return <Typography className='attractiondialog-section-text' key={index}>
                        {d}
                    </Typography>;
                })
            }
        </Box>

        {/* Opening hours */}
        {
            attraction?.openingHours && <Box className='attractiondialog-section'>
                <Typography className='attractiondialog-section-title'>
                    {translate('openingHours')}
                </Typography>

                <Box className='openinghour-container'>
                    {
                        attraction.openingHours.map((item: any, index: number) => {
                            return <Box className='openinghour-item' key={index}>
                                <Typography className='openinghour-item-label'>{translate(item.label)}</Typography>
                                <Typography className='openinghour-item-value'>{item.value.replace('{at}', translate('at'))}</Typography>
                            </Box>;
                        })
                    }
                </Box>
            </Box>
        }

        {/* Location */}
        {
            attraction?.googleMaps && <Box className='attractiondialog-section'>
                <Typography className='attractiondialog-section-title'>
                    {translate('location')}
                </Typography>

                <iframe 
                    src={attraction.googleMaps} 
                    title={`${attraction.key}-location`} 
                    className='attractiondialog-location'  
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade" 
                />
            </Box>
        }


        {/* Gallery */}
        <Box className='attractiondialog-section section-gallery'>
            <Typography className='attractiondialog-section-title'>
                {translate('galleryTitle')}
            </Typography>

            <Gallery items={attraction?.gallery ?? []} size='medium' showTitle={false} showDescription={false} />
        </Box>

        {/* Request quote */}
        <RequestQuote variant={attraction?.requestQuoteVariant ?? 'default'} />
    </Dialog>;
}

export default AttractionDialog;